import React from 'react'
import {FormattedMessage, useIntl} from 'react-intl'
import {useWishList} from '../../../hooks/use-wish-list'
import {Text, Box, Image, Link} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {useGlobaleContext} from '../../../contexts/globale'
import {useSiteContext} from '../../../contexts/site'
import {getUrl} from '../../../utils/cloudinary-utils'
import {KS_WISHLIST_URL} from '../../../constants'

const WishlistCount = () => {
    const intl = useIntl()
    const {isYR} = useSiteContext()
    const {data: wishListData} = useWishList()
    const {countryISO} = useGlobaleContext()

    const {
        app: {commerceAPI}
    } = getConfig()
    const {hostUrl} = commerceAPI.storefront

    return (
        countryISO === 'US' && (
            <Box display="flex">
                <Link
                    href={hostUrl + KS_WISHLIST_URL}
                    className="heart-icon"
                    data-wishlist-count={wishListData?.customerProductListItems?.length}
                    display="flex"
                    onClick={() => {}}
                    _hover={{textDecoration: 'none'}}
                    marginBottom="1rem"
                    width="fit-content"
                    fontWeight="300"
                    fontSize="14px"
                    color="black.100"
                    gap="0.8rem"
                >
                    <Image
                        alt="Favorite Icon"
                        width="15px"
                        height="21px"
                        src={getUrl(
                            isYR
                                ? 'UIImages/images/heart-icon.svg'
                                : 'UIImages/images/heart-black.svg'
                        )}
                    />
                    <FormattedMessage id="favorites" defaultMessage="Favorites" />
                </Link>

                {wishListData?.customerProductListItems?.length ? (
                    <Text fontWeight="300" fontSize="14px" marginLeft="5px" color="black.100">
                        {intl.formatMessage(
                            {
                                id: 'wishlist.count',
                                defaultMessage: '({count})'
                            },
                            {
                                count: wishListData?.customerProductListItems?.length
                            }
                        )}
                    </Text>
                ) : null}
            </Box>
        )
    )
}

export default WishlistCount
